export default __webpack_public_path__ + "static/media/up.f2fb7a8d.svg";